import { TextField } from '@mui/material';
import { TFormValues } from '../../types';
import { useTranslation } from 'react-i18next';

interface IProps {
    relocationDate: string;
    getFieldError: (fieldName: keyof TFormValues) => string | undefined;
    setFieldValue(field: keyof TFormValues, value: string): void;
}

export const RelocationDateInput = ({
    relocationDate,
    getFieldError,
    setFieldValue,
}: IProps) => {
    const { t } = useTranslation();

    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const prevValue = relocationDate;
        let newValue = e.target.value;

        const backspaceButtonPressed = newValue === prevValue.slice(0, -1);
        const prevValEndsOnHyphen = prevValue.slice(-1) === '-';
        // The second hyphen is different (an em dash)
        const newValEndsOnHyphen = ['-', '—'].includes(newValue.slice(-1));

        if (backspaceButtonPressed && prevValEndsOnHyphen) {
            // Also delete character before hyphen when hyphen deleted
            setFieldValue('relocationDate', newValue.slice(0, -1));

            return;
        }

        // I.E. if user input is 9- convert into 09-
        if (newValue.match(/^[0-9]{1}-$/)) {
            newValue = `0${newValue}`;
            setFieldValue('relocationDate', newValue);

            return;
        }

        // I.E. if user input is 09-1- convert into 09-01-
        if (newValue.match(/^[0-9]{2}-[0-9]{1}-$/)) {
            newValue = newValue.slice(0, 3) + '0' + newValue.slice(-2);
            setFieldValue('relocationDate', newValue);

            return;
        }

        // Prevents the user accidentally adding hyphen
        if (!backspaceButtonPressed && newValEndsOnHyphen) {
            return;
        }

        // Append hyphen when value equals format "dd" or "dd-mm"
        if (newValue.match(/^[0-9]{2}$|^[0-9]{2}-[0-9]{2}$/)) {
            newValue = newValue.concat('-');
            setFieldValue('relocationDate', newValue);

            return;
        }

        setFieldValue('relocationDate', newValue);
    };

    return (
        <TextField
            error={!!getFieldError('relocationDate')}
            helperText={getFieldError('relocationDate')}
            id="relocationDate"
            inputProps={{
                maxLength: 10,
            }}
            label={t('relocationDate') + ' *'}
            placeholder={t('dateFormat') || ''}
            value={relocationDate}
            onChange={handleDateChange}
        />
    );
};
